import React from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Mail, BookOpen, Twitter, ArrowUp } from 'lucide-react';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.4, delay, ease: [0.22, 1, 0.36, 1] },
});

const socials = [
  { label: 'GitHub',   href: 'https://github.com/Krishna41357',                      Icon: Github,   id: 'github' },
  { label: 'LinkedIn', href: 'https://linkedin.com/in/krishna-srivastava-a84b65299', Icon: Linkedin, id: 'linkedin' },
  { label: 'Medium',   href: 'https://medium.com/@krishnasrivastava41357',            Icon: BookOpen, id: 'medium' },
  { label: 'X',        href: 'https://x.com/Krishna91135239',                        Icon: Twitter,  id: 'twitter' },
];

export default function Footer() {
  return (
    <footer
      id="contact"
      className="relative w-full overflow-hidden bg-transparent border-t border-black/8 pt-10 pb-8"
    >
      <div className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 lg:px-14">

        {/* ── CTA block ── */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-8">
          <div>
            <motion.p {...fadeUp(0)} className="font-mono text-[10px] uppercase tracking-[0.2em] text-purple-600 font-bold mb-1">
              &lt;/Contact&gt;
            </motion.p>
            <motion.h2 {...fadeUp(0.04)} className="text-2xl sm:text-3xl font-black text-black leading-tight">
              Let's build something<br />
              <span className="text-purple-600">together.</span>
            </motion.h2>
            <motion.p {...fadeUp(0.08)} className="text-[12px] text-black/40 font-mono mt-2">
              Open to internships, freelance work, and interesting conversations.
            </motion.p>
          </div>

          {/* Email CTA */}
          <motion.a
            {...fadeUp(0.1)}
            href="mailto:krishnasrivastava41357@gmail.com"
            className="inline-flex items-center gap-2 px-5 py-3 bg-black text-white text-sm font-black rounded-xl border border-black hover:bg-purple-600 hover:border-purple-600 transition-colors duration-200 whitespace-nowrap"
          >
            <Mail size={14} />
            Send an email
          </motion.a>
        </div>

        <motion.div {...fadeUp(0.12)} className="h-px bg-black/10 mb-6" />

        {/* ── Bottom bar ── */}
        <div className="flex items-center justify-between gap-4 flex-wrap">

          {/* Social links */}
          <motion.div {...fadeUp(0.14)} className="flex items-center gap-2 flex-wrap">
            {socials.map(({ label, href, Icon, id }) => (
              <a
                key={id}
                href={href}
                target={id !== 'mail' ? '_blank' : undefined}
                rel="noopener noreferrer"
                title={label}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white border border-black/10 text-black/50 hover:text-purple-600 hover:border-purple-300 text-[11px] font-mono font-semibold transition-all duration-200"
              >
                <Icon size={12} />
                {label}
              </a>
            ))}
          </motion.div>

          {/* Copyright */}
          <motion.p {...fadeUp(0.16)} className="text-[10px] font-mono text-black/30">
            © {new Date().getFullYear()} Krishna Srivastava
          </motion.p>

        </div>

      </div>

      {/* Back to top */}
      <a
        href="#top"
        title="Back to top"
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-10 h-10 bg-purple-600 text-white border-2 border-black rounded-xl shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:shadow-none hover:translate-x-[3px] hover:translate-y-[3px] transition-all duration-150"
      >
        <ArrowUp size={16} />
      </a>
    </footer>
  );
}